<script setup lang="ts">
defineProps({
	link: {
		type: String,
		default: '',
	},
	name: {
		type: String,
		default: '',
	},
});
</script>

<template>
	<a :href="link" class="text-sm sm:text-base flex items-center gap-1 text-hintText hover:text-secondaryText transition">
		<span>{{ name }}</span>
		<img src="/src/shared/assets/icons/external-link.svg" alt="" />
	</a>
</template>

<style scoped></style>
